import t from "@emotion/styled/base";
import { Text as e } from "../../../Text/index.js";
function n() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const o = /* @__PURE__ */ t(e, process.env.NODE_ENV === "production" ? {
  target: "e1y0ir1m0"
} : {
  target: "e1y0ir1m0",
  label: "CountText"
})(process.env.NODE_ENV === "production" ? {
  name: "aakjv1",
  styles: "justify-content:flex-end;text-align:right;width:100%;max-width:fit-content"
} : {
  name: "aakjv1",
  styles: "justify-content:flex-end;text-align:right;width:100%;max-width:fit-content/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGV4dElucHV0L3N1YkNvbXBvbmVudHMvQ291bnQvQ291bnQuc3R5bGVkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlxQyIsImZpbGUiOiIvaG9tZS9ydW5uZXIvd29yay9wYXJ0b28tdWkvcGFydG9vLXVpL3BhY2thZ2VzL3VpL3NyYy9jb21wb25lbnRzL1RleHRJbnB1dC9zdWJDb21wb25lbnRzL0NvdW50L0NvdW50LnN0eWxlZC50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuaW1wb3J0IHsgVGV4dCB9IGZyb20gJy4uLy4uLy4uL1RleHQnO1xuXG5leHBvcnQgY29uc3QgQ291bnRUZXh0ID0gc3R5bGVkKFRleHQpYFxuICAgIGp1c3RpZnktY29udGVudDogZmxleC1lbmQ7XG4gICAgdGV4dC1hbGlnbjogcmlnaHQ7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgbWF4LXdpZHRoOiBmaXQtY29udGVudDtcbmA7XG4iXX0= */",
  toString: n
});
export {
  o as CountText
};
